"use strict";

module.exports = {
    "m-footer": {
        "feedback": "Обратная связь",
        "confidential": "Конфиденциально",
        "guide": "Водство",
        "about": "О сервисе",
        "yandex_info": "Коммерческая тайна ООО «Яндекс», 119021, Россия, г. Москва, ул. Льва Толстого, д. 16",
        "mobile": "Мобильная версия"
    }
};